<template>
  <v-dialog :model-value="modelValue" persistent max-width="700" :fullscreen="$store.state.isMobile">
    <v-card>
      <v-card-title class="d-flex align-center">{{ required ? 'Passkey Required' : 'Set Up a Passkey' }} <encryption-gen-badge generation="new" /></v-card-title>
      <v-card-text>
        <div class="text-subtitle-1 mb-3" v-if="required">
          A passkey is now required to protect your end-to-end encrypted data.
          You'll be asked to use your device's screen lock (Windows Hello,
          Touch ID, or similar) to save it.
        </div>
        <!-- A host may say WHY it is asking (the post-unlock offer: "you just
             used your recovery code" / "your keys just arrived"). -->
        <div class="text-subtitle-1 mb-3" v-else-if="intro">{{ intro }}</div>
        <!-- Same split as RecoveryCodeDialog (2026-10-08): a view-only
             accountability partner has no screenshots of their own. -->
        <div class="text-subtitle-1 mb-3" v-else-if="$store.getters.isViewOnlyPartner">
          Protect your end-to-end encrypted data with a passkey. It unlocks
          the screenshots shared with you using your device's password manager.
        </div>
        <div class="text-subtitle-1 mb-3" v-else>
          Protect your end-to-end encrypted data with a passkey. It unlocks
          your encrypted screenshots with your device's password manager.
        </div>
        <v-alert type="info" variant="tonal" density="compact" class="mb-4">
          Depending on your browser, you may be prompted twice: once to create
          the passkey and once to activate it.
        </v-alert>
        <v-alert v-if="errorMessage" type="error" variant="tonal" density="compact" class="mb-2">
          {{ errorMessage }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="!required" variant="text" :disabled="working" @click="skip">Skip for now</v-btn>
        <v-spacer />
        <v-btn variant="elevated" color="primary" :loading="working" @click="enroll">
          {{ errorMessage ? 'Try again' : 'Set up passkey' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { registerPasskeyWithPrf } from '@/services/e2ee/nc1/PasskeyPrf'

  // Consent + ceremony dialog for passkey (WebAuthn PRF) enrollment. The
  // WebAuthn calls run inside the button's click handler so they carry a real
  // user gesture. In `required` mode there is no skip — a failed ceremony
  // shows the error and offers retry (closing the tab just means the
  // required-mode catch-up runs again at next login).
  export default {
    name: 'PasskeySetupDialog',
    props: {
      modelValue: {
        type: Boolean,
        default: false
      },
      required: {
        type: Boolean,
        default: false
      },
      email: {
        type: String,
        default: ''
      },
      prfSaltB64: {
        type: String,
        default: ''
      },
      // Optional replacement for the default (non-required) intro paragraph.
      intro: {
        type: String,
        default: ''
      }
    },
    emits: ['update:modelValue', 'enrolled', 'skipped'],
    data() {
      return {
        working: false,
        errorMessage: null
      }
    },
    methods: {
      async enroll() {
        this.working = true
        this.errorMessage = null
        try {
          const material = await registerPasskeyWithPrf({
            email: this.email,
            prfSaltB64: this.prfSaltB64
          })
          this.$emit('update:modelValue', false)
          this.$emit('enrolled', material)
        } catch(e) {
          console.log('passkey enrollment failed', e)
          this.errorMessage = 'That didn\'t work. Your device may have cancelled the request. Please try again.'
        } finally {
          this.working = false
        }
      },
      skip() {
        this.$emit('update:modelValue', false)
        this.$emit('skipped')
      }
    }
  }
</script>
